export const getSelectedVehicle = ({ app }) =>
  app.data.userdata.mygarage.activeVehicleDetails
